export default __webpack_public_path__ + "static/JoeEnginesPreview-bbc74777b4e366409fc06f74a76e5e14.png";